import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemState {
  statusError?: ErrorStatusCode;
  showModalError: boolean;
}

const initialState: SystemState = {
  showModalError: false,
};
export const systemSlice = createSlice({
  name: 'systemReducer',
  initialState,
  reducers: {
    setGlobalError($state, action: PayloadAction<ErrorStatusCode>) {
      if (!$state.showModalError) {
        $state.statusError = action.payload;
        $state.showModalError = true;
      }
    },
    hideModalError($state) {
      $state.showModalError = false;
    },
  },
  extraReducers() {
  }
});

export const {
  setGlobalError, hideModalError,
} = systemSlice.actions;

export default systemSlice.reducer;
